// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qc-9";
export var arrowButtonContainer = "_qc-5";
export var arrowButtonIcon = "_qc-6";
export var carouselArrowButton = "_qc-2";
export var carouselElementContainer = "_qc-1";
export var currentSlide = "_qc-8";
export var left = "_qc-3";
export var otherSlide = "_qc-a";
export var productCarouselContainer = "_qc-0";
export var right = "_qc-4";
export var sliderOverflow = "_qc-7";